function Footer() {
    return (
        <footer>
            <div className="content-wrapper">
                <p>({new Date().getFullYear()}) Design & Entwicklung von <a href="https://github.com/NateMS">Nadim Salloum</a></p>
            </div>
        </footer>
    );
}

export default Footer;
